import { useLanguage } from "../i18n/LanguageContext";
import { SEOHead } from "../components/SEOHead";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { TrustCards } from "../components/home/TrustCards";
import { RoomsOverview } from "../components/home/RoomsOverview";
import { Highlights } from "../components/home/Highlights";
import { LocationSection } from "../components/home/LocationSection";
import { PriceCTA } from "../components/home/PriceCTA";
import { ContactCTA } from "../components/home/ContactCTA";

export default function Home() {
  const { t } = useLanguage();
  return (
    <main data-testid="home-page">
      <SEOHead title={t.meta.home.title} description={t.meta.home.description} withStructuredData />
      <Hero />
      <Marquee />
      <TrustCards />
      <RoomsOverview />
      <Highlights />
      <LocationSection />
      <div className="h-20 md:h-28" />
      <PriceCTA />
      <ContactCTA />
    </main>
  );
}
